import React = require("react");

export enum MetaTypes {
    date = 1,
    number = 2,
    text = 3
}

export interface IMeta {
    key: string;
    value: string;
    type: MetaTypes;
}

export interface ICardMetaProps {
    meta: IMeta[];
}

export const CardMeta = (props: ICardMetaProps): React.ReactElement<ICardMetaProps> => {
    return (
        <div className="wpo ui content table">
            {
                props.meta.map((item: IMeta, index: number) => {
                    
                    if(!(item.value) || item.value == "") {
                        return null
                    }

                    return (
                        <div key={index}>
                            <span>
                                {
                                    `${item.key}: ${item.value}`
                                }
                            </span>
                        </div>
                    )
                })
            }
        </div>
    );
}